import axios from 'axios'
import qs from 'qs'
import md5 from 'md5'
import store from '@/store';

axios.defaults.withCredentials = true

const APP_ID = '2b6411497d8b4dcf843aa55176a9663e'
const APP_SECRET = '406398852fe087a5538a027f1fdca1a3fb327cc5eae94715ec8f2f19ebfaf8cb'

let config = {
  baseUrl: '',
  beforeSuccess: (res, resolve) => {
    resolve(res)
  },
  beforeError: (res, reject) => {
    reject(res)
  }
}

const signRequest = (url, method, body) => {
  let signString = ''
  switch (method.toUpperCase()) {
    case 'GET':
      signString = `${url}`
      break
    case 'POST':
      if (!(body instanceof window.FormData)) {
        signString = JSON.stringify(body)
      }
      break
  }
  return md5(`${APP_ID}${signString}${APP_SECRET}`)
}

const request = (url, method = 'post', data = {}, axiosConfig, noBase) => {
  return new Promise((resolve, reject) => {
    if (data) {
      for (let key of Object.keys(data)) {
        let newUrl = url.replace(new RegExp('\\{' + key + '}', 'g'), data[key])
        if (url !== newUrl) {
          delete data[key]
        }
        url = newUrl
      }
    }
    if (method === 'get' && qs.stringify(data)) {
      url += `?${qs.stringify(data)}`
    }

    if (url.indexOf('?') !== -1) {
      url += '&temp=' + new Date().getTime()
    } else {
      url += '?temp=' + new Date().getTime()
    }

    let { phone, uniqueId, openid, unionid } = store.getters.info;

    axios({
      method,
      url: noBase ? url : config.baseUrl + url,
      data,
      headers: {
        // 注册来源  1--> PC
        'channelId': 1,
        appId: APP_ID,
        sign: signRequest(config.baseUrl + url, method, data),
        token: localStorage.getItem('token') || '',
        phone: phone || '',
        uniqueId: uniqueId || '',
        openid: openid || '',
        unionid: unionid || '',
      },
      withCredentials: !noBase,
      ...axiosConfig
    }).then(res => {
      config.beforeSuccess(res, resolve, reject)
    }, res => {
      config.beforeError(res, reject)
    })
  })
}

request.setConfig = (conf = {}) => {
  config = { ...config, ...conf }
}

request.timeOut = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, 2000)
  })
}

export default request



// WEBPACK FOOTER //
// ./src/assets/js/request.js